import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {stAbsenceApi} from '@/services/st-api';
import {UserStore} from '@/store/user-module';

@Module({ dynamic: true, store, name: 'AbsenceModule', namespaced: true })
export default class AbsenceModule extends VuexModule {
  public openAbsenceRequestCount: number = 0;

  @Mutation
  setOpenAbsenceRequestCount(data: number) {
    this.openAbsenceRequestCount = data;
  }

  @Action
  async getOpenAbsenceRequestCount() {
    if (UserStore.userSettings.CanApproveAbsences) {
      let result = await stAbsenceApi.getOpenAbsenceRequestCount();
      this.setOpenAbsenceRequestCount(result);
    }
  }
}

export const AbsenceStore = getModule(AbsenceModule);
